export default "__VITE_ASSET__a495d793__"